.root {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px 10px 10px;
  min-height: 56px;
  flex-wrap: wrap;
}

.spacer {
  flex: 1 1 auto;
}

.clearAll {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(
    --chartv2-text-primary,
    var(--text-primary, var(--chartv2-foreground, #ffc53d))
  );
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  line-height: 1;
  margin-left: auto;
}

.clearAll:hover {
  background: var(--chartv2-chip-hover, rgba(255, 255, 255, 6%));
}

.flexWrapper {
  display: flex;
  gap: 4px;
  align-items: center;
}
